import {useEffect, useState} from 'react'
import {PopupSize, PopupTemplate} from './popup_template'
import {createDispatchActions, selectTheme} from '../../store'
import {IIdentityAnnouncement} from '../../shared/db/identity_announcement'

export const PopupNewFeature = (props: {announcementList: IIdentityAnnouncement[]; onClose: () => void}) => {
  const {fontWeight, color} = selectTheme()
  const {announcementList, onClose} = props
  const [currentFeatureIndex, setCurrentFeatureIndex] = useState(0)
  const currentAnnouncement = announcementList[currentFeatureIndex]
  const {doREQUEST_IDENTITY_ANNOUNCEMENT_READ} = createDispatchActions()

  useEffect(() => {
    if (!currentAnnouncement) return
    doREQUEST_IDENTITY_ANNOUNCEMENT_READ({
      payload: {
        announcementId: currentAnnouncement.id,
      },
    })
  }, [currentAnnouncement])

  const handleNextFeature = () => {
    if (currentFeatureIndex === announcementList.length - 1) {
      onClose()
      return
    }
    setCurrentFeatureIndex(currentFeatureIndex + 1)
  }

  return (
    <PopupTemplate
      title={currentAnnouncement.title}
      description={
        <p>
          {currentAnnouncement.content}
          {currentAnnouncement.link && (
            <a
              css={{color: color.textIcon.link, marginLeft: '4px'}}
              href={currentAnnouncement.link}
              target='_blank'
              rel='noopener noreferrer'>
              Learn More
            </a>
          )}
        </p>
      }
      bannerImgUrl={currentAnnouncement.mediaUrl}
      mainFunction={handleNextFeature}
      buttonContent={currentFeatureIndex === announcementList.length - 1 ? 'I Got It' : 'Next'}
      background={true}
      popupSize={PopupSize.Medium}
      handleClosePopup={onClose}
      optionalBottomLeftContent={
        announcementList.length > 1 && (
          <span
            css={{
              fontWeight: fontWeight.thick,
              color: color.textIcon.secondary,
            }}>
            {currentFeatureIndex + 1} / {announcementList.length}
          </span>
        )
      }
    />
  )
}
